export const GENDER = 'gender'
export const GENDER_OPTION = 'gender_option'
export const GENDER_OPTION_ALL = 'gender_option_all'
export const GENDER_OPTION_MALES = 'gender_option_males'
export const GENDER_OPTION_FEMALES = 'gender_option_females'
